
import 'regenerator-runtime/runtime';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import OverAllReport from "./components/OverAllReport.js";
import LearnerReport from "./components/LearnerReport.js";
import CourseReport from "./components/CourseReport";
import Notfound from "./components/Notfound";
import SystemProvider from "./service/SystemProvider";
class App extends React.Component {
constructor(props) {
  super(props);
  this.state = {}
}
componentDidMount() {    
}
handleSelect=(ranges)=>{
}
render() {
return (<div>
  <HashRouter>
    <SystemProvider>
      <Switch>
        <Route exact path="/" component={OverAllReport} />
        <Route exact path="/learner_report/:id/:cid" component={LearnerReport} />
        <Route exact path="/course_report/:cid" component={CourseReport} />
        <Redirect to="/" />
        {/*  <Route exact component={OverAllReport} />
        <Route exact component={Notfound} /> */}
      </Switch>
    </SystemProvider>
  </HashRouter>




</div>);
}
}

ReactDOM.render(<App />, document.getElementById("reactblock"));